import type { Track } from '../schemas/classify';

export const TRACK_DISPLAY_NAMES = {
  Attention: 'Inbox',
  Archive: 'Archive',
  Trash: 'Trash',
} as const satisfies Record<Track, string>;

export type TrackDisplayName = (typeof TRACK_DISPLAY_NAMES)[Track];

export function getTrackDisplayName(track: Track): TrackDisplayName {
  return TRACK_DISPLAY_NAMES[track];
}
